(() => {
  const root = document.querySelector("[data-te-cart-clone]");
  if (!root) return;

  const body = root.querySelector("[data-te-cart-body]");
  const title = root.querySelector("[data-te-cart-title]");
  const footer = root.querySelector("[data-te-cart-footer]");
  const savingsNode = root.querySelector("[data-te-cart-savings]");
  const checkoutButton = root.querySelector("[data-te-cart-checkout]");
  const headerCart = document.querySelector(".cart-button");
  const cartCount = document.querySelector("[data-cart-count]");
  const sticky = document.querySelector("[data-te-sticky-cart]");
  const siliconeType = (root.dataset.siliconeType || "Silicone Ring").toLowerCase();
  const tiers = [
    { quantity: 1, discount: 0 },
    { quantity: 2, discount: 15 },
    { quantity: 3, discount: 20 },
    { quantity: 4, discount: 25 },
  ];
  const productCache = new Map();
  let currentCart = null;
  let isRendering = false;

  const money = (cents) => {
    const amount = Number(cents || 0) / 100;
    return amount.toLocaleString("en-AU", { style: "currency", currency: "AUD" }).replace("A$", "");
  };

  const escapeHtml = (value = "") =>
    String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  const isEligibleItem = (item) => {
    const type = String(item.product_type || "").toLowerCase();
    const titleText = String(item.product_title || item.title || "").toLowerCase();
    return type.includes(siliconeType) || titleText.includes("silicone ring");
  };

  const getTier = (count) => {
    if (count >= 4) return tiers[3];
    if (count >= 3) return tiers[2];
    if (count >= 2) return tiers[1];
    return tiers[0];
  };

  const getDiscountCode = (quantity) => {
    if (quantity >= 4) return root.getAttribute("data-discount-4") || "";
    if (quantity >= 3) return root.getAttribute("data-discount-3") || "";
    if (quantity >= 2) return root.getAttribute("data-discount-2") || "";
    return "";
  };

  const discountedUnit = (unitPrice, discount) => {
    if (!discount) return unitPrice;
    if (unitPrice === 2999 && discount === 15) return 2550;
    return Math.round(unitPrice * (100 - discount) / 100);
  };

  const cartFetch = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: "same-origin",
      headers: { Accept: "application/json", ...(options.headers || {}) },
      ...options,
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  };

  const fetchCart = () => cartFetch("/cart.js");

  const changeLine = (id, quantity) =>
    cartFetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, quantity }),
    });

  const addVariant = (variantId, quantity = 1) =>
    cartFetch("/cart/add.js", {
      method: "POST",
      body: new URLSearchParams({ id: variantId, quantity: String(quantity) }),
    });

  const fetchProduct = async (handle) => {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);
    const product = await cartFetch(`/products/${handle}.js`);
    productCache.set(handle, product);
    return product;
  };

  const handleFromItem = (item) => item.handle || String(item.url || "").split("/products/")[1]?.split("?")[0]?.split("/")[0] || "";

  const updateCount = (cart) => {
    if (cartCount) cartCount.textContent = String(cart?.item_count || 0);
  };

  const openCart = async () => {
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("te-cart-open");
    await renderCart();
  };

  const closeCart = () => {
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("te-cart-open");
  };

  const lineImage = (item) => {
    if (!item.image) return "";
    return `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title || item.title)}" loading="lazy">`;
  };

  const renderVariantSelect = (item) => {
    const options = (item.options_with_values?.[0]?.values || []).map((value) => value.name || value);
    if (!options.length) return item.variant_title ? `<span>${escapeHtml(item.variant_title)}</span>` : "";
    return `
      <select class="te-cart-clone__variant" data-te-line-variant="${escapeHtml(item.key)}" aria-label="Variant for ${escapeHtml(item.product_title)}">
        ${options.map((option) => `<option ${option === item.variant_title ? "selected" : ""}>${escapeHtml(option)}</option>`).join("")}
      </select>
    `;
  };

  const renderLine = (item, groupedLabel = "") => `
    <article class="te-cart-clone__line">
      <a class="te-cart-clone__image" href="${escapeHtml(item.url || "#")}">${lineImage(item)}</a>
      <div class="te-cart-clone__line-main">
        <div class="te-cart-clone__line-head">
          <a href="${escapeHtml(item.url || "#")}">${escapeHtml(item.product_title || item.title)}</a>
          <button type="button" data-te-remove-line="${escapeHtml(item.key)}" aria-label="Remove item from cart">x</button>
        </div>
        ${renderVariantSelect(item)}
        <div class="te-cart-clone__line-bottom">
          <strong>${groupedLabel || money((item.final_price || item.price || 0) * item.quantity)}</strong>
          <div class="te-cart-clone__qty">
            <button type="button" data-te-qty-dec="${escapeHtml(item.key)}" aria-label="Decrease item quantity">-</button>
            <span>${item.quantity}</span>
            <button type="button" data-te-qty-inc="${escapeHtml(item.key)}" aria-label="Increase item quantity">+</button>
          </div>
        </div>
      </div>
    </article>
  `;

  const renderTierButton = (tier, active, unitPrice) => {
    const label = tier.quantity >= 4 ? "Buy 4+" : `Buy ${tier.quantity}`;
    const price = discountedUnit(unitPrice, tier.discount);
    return `
      <button class="te-cart-clone__tier ${active ? "is-active" : ""}" type="button" data-te-tier="${tier.quantity}">
        <span>${label} save ${tier.discount}%</span>
        <strong>${money(price)} each</strong>
      </button>
    `;
  };

  const buildTierSelector = async (item, targetQuantity) => {
    const existing = body.querySelector("[data-te-tier-builder]");
    existing?.remove();
    const handle = handleFromItem(item);
    const product = await fetchProduct(handle);
    if (!product) return;

    const currentEligibleCount = currentCart.items.filter(isEligibleItem).reduce((sum, line) => sum + line.quantity, 0);
    const missing = Math.max(0, targetQuantity - currentEligibleCount);
    if (!missing) return;

    const options = product.variants
      .map((variant) => `<option value="${variant.id}" ${variant.available ? "" : "disabled"}>${escapeHtml(variant.title)}${variant.available ? "" : " (Sold out)"}</option>`)
      .join("");

    const builder = document.createElement("form");
    builder.className = "te-cart-clone__bundle-builder";
    builder.dataset.teTierBuilder = "true";
    builder.innerHTML = `
      <h3>Select product #${currentEligibleCount + 1}</h3>
      ${Array.from({ length: missing }, (_, index) => `
        <label>
          <span>Size</span>
          <select name="variant_${index}">${options}</select>
        </label>
      `).join("")}
      <button type="submit">Confirm</button>
    `;
    builder.addEventListener("submit", async (event) => {
      event.preventDefault();
      const button = builder.querySelector("button");
      button.disabled = true;
      try {
        const values = Array.from(builder.querySelectorAll("select")).map((select) => select.value).filter(Boolean);
        for (const value of values) await addVariant(value, 1);
        await renderCart();
      } finally {
        button.disabled = false;
      }
    });
    const tierBlock = body.querySelector(".te-cart-clone__tiers");
    tierBlock?.after(builder);
  };

  const renderCart = async () => {
    if (isRendering) return;
    isRendering = true;
    try {
      currentCart = await fetchCart();
      updateCount(currentCart);
      title.textContent = `Your Cart (${currentCart.item_count || 0})`;

      if (!currentCart.item_count) {
        body.innerHTML = `
          <div class="te-cart-clone__empty">
            <p>Your cart is empty.</p>
            <a href="/#shop">Shop best sellers</a>
          </div>
        `;
        footer.hidden = true;
        isRendering = false;
        return;
      }

      const eligible = currentCart.items.filter(isEligibleItem);
      const eligibleCount = eligible.reduce((sum, item) => sum + item.quantity, 0);
      const activeTier = getTier(eligibleCount);
      const eligibleSubtotal = eligible.reduce((sum, item) => sum + (item.original_price || item.price || 0) * item.quantity, 0);
      const eligibleDiscounted = activeTier.discount
        ? eligible.reduce((sum, item) => sum + discountedUnit(item.original_price || item.price || 0, activeTier.discount) * item.quantity, 0)
        : eligibleSubtotal;
      const previewSavings = Math.max(0, eligibleSubtotal - eligibleDiscounted);
      const appliedSavings = Math.max(0, currentCart.total_discount || 0);
      const savings = appliedSavings || previewSavings;
      const checkoutTotal = appliedSavings ? currentCart.total_price : Math.max(0, currentCart.total_price - savings);
      const unitPrice = eligible[0]?.original_price || eligible[0]?.price || 2999;

      body.innerHTML = currentCart.items
        .map((item) => renderLine(item, isEligibleItem(item) && eligibleCount >= 2 ? `BUNDLE PACK x${eligibleCount}` : ""))
        .join("");

      if (eligible.length) {
        const visibleTiers = tiers.filter((tier) => eligibleCount < 2 || tier.quantity >= Math.min(eligibleCount, 4));
        body.insertAdjacentHTML("beforeend", `
          <div class="te-cart-clone__tiers">
            ${visibleTiers.map((tier) => renderTierButton(tier, activeTier.quantity === tier.quantity || (eligibleCount >= 4 && tier.quantity === 4), unitPrice)).join("")}
          </div>
        `);
      }

      savingsNode.hidden = !savings;
      savingsNode.textContent = savings ? `Savings -${money(savings)}` : "";
      footer.hidden = false;
      checkoutButton.textContent = `Checkout • ${money(checkoutTotal)}`;
      checkoutButton.dataset.checkoutDiscount = getDiscountCode(eligibleCount);
    } finally {
      isRendering = false;
    }
  };

  body.addEventListener("click", async (event) => {
    const remove = event.target.closest("[data-te-remove-line]");
    const dec = event.target.closest("[data-te-qty-dec]");
    const inc = event.target.closest("[data-te-qty-inc]");
    const tier = event.target.closest("[data-te-tier]");
    try {
      if (remove) {
        await changeLine(remove.dataset.teRemoveLine, 0);
        await renderCart();
      } else if (dec || inc) {
        const key = dec?.dataset.teQtyDec || inc?.dataset.teQtyInc;
        const item = currentCart.items.find((line) => line.key === key);
        if (!item) return;
        await changeLine(key, Math.max(0, item.quantity + (inc ? 1 : -1)));
        await renderCart();
      } else if (tier) {
        const item = currentCart.items.find(isEligibleItem);
        if (!item) return;
        const quantity = Number(tier.dataset.teTier || 1);
        const currentEligibleCount = currentCart.items.filter(isEligibleItem).reduce((sum, line) => sum + line.quantity, 0);
        if (quantity > currentEligibleCount) await buildTierSelector(item, quantity);
      }
    } catch (error) {
      console.warn("TE cart clone action failed", error);
    }
  });

  root.querySelectorAll("[data-te-cart-close]").forEach((button) => button.addEventListener("click", closeCart));
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeCart();
  });

  checkoutButton.addEventListener("click", () => {
    const code = checkoutButton.dataset.checkoutDiscount;
    if (code) {
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
    } else {
      window.location.href = "/checkout";
    }
  });

  headerCart?.addEventListener("click", (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openCart();
  });

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest("form[action*='/cart/add']");
    if (!form || form.dataset.teCartIgnore === "true") return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector("button[type='submit'], input[type='submit']");
    button?.setAttribute("disabled", "disabled");
    try {
      await cartFetch(form.action || "/cart/add.js", { method: "POST", body: new FormData(form) });
      await openCart();
    } catch (error) {
      console.warn("TE cart clone add failed", error);
      form.submit();
    } finally {
      button?.removeAttribute("disabled");
    }
  }, true);

  const setupStickyCart = () => {
    if (!sticky || !document.querySelector(".product-page-section")) return;
    const form = document.querySelector("form.shopify-product-form");
    if (!form) return;
    const titleNode = document.querySelector(".purchase-panel h1, .purchase-panel h2");
    const priceNode = document.querySelector("[data-product-price]");
    const variantInput = form.querySelector("[data-variant-input], input[name='id']");
    const qtyInput = form.querySelector("input[name='quantity']");
    const variantSelect = sticky.querySelector("[data-te-sticky-variant]");
    const stickyQty = sticky.querySelector("[data-te-sticky-qty]");
    const submit = sticky.querySelector("[data-te-sticky-submit]");

    sticky.querySelector("[data-te-sticky-title]").textContent = titleNode?.textContent?.trim() || "Product";
    sticky.querySelector("[data-te-sticky-price]").textContent = priceNode?.textContent?.trim() || "";

    const variants = Array.from(form.querySelectorAll(".size-grid button[data-variant-id]"));
    variantSelect.innerHTML = variants.map((button) => `
      <option value="${button.dataset.variantId}" ${button.disabled ? "disabled" : ""} ${button.classList.contains("is-active") ? "selected" : ""}>
        ${escapeHtml(button.textContent.trim())}${button.disabled ? " (Sold out)" : ""}
      </option>
    `).join("");

    variantSelect.addEventListener("change", () => {
      const matching = form.querySelector(`.size-grid button[data-variant-id="${CSS.escape(variantSelect.value)}"]`);
      matching?.click();
      if (variantInput) variantInput.value = variantSelect.value;
    });

    sticky.querySelector("[data-te-sticky-dec]").addEventListener("click", () => {
      stickyQty.value = String(Math.max(1, Number(stickyQty.value || 1) - 1));
    });
    sticky.querySelector("[data-te-sticky-inc]").addEventListener("click", () => {
      stickyQty.value = String(Number(stickyQty.value || 1) + 1);
    });
    submit.addEventListener("click", () => {
      if (variantInput) variantInput.value = variantSelect.value;
      if (qtyInput) qtyInput.value = stickyQty.value || "1";
      form.requestSubmit();
    });

    sticky.hidden = false;
  };

  setupStickyCart();
  window.TECartClone = { open: openCart, close: closeCart, refresh: renderCart };
})();
